export function MembershipsPage() {
   return (
      <div>
         <h1>Memberships</h1>
         <p>Memberships page content</p>
      </div>
   );
}
